import { CustomComponentType } from '../../../enums/custom-component-type';
import { CollectionResponseDataFieldOption, DataFieldOption } from '@sageworks/jpi';
import EditableApiSelectOptions from '../editable-api-select-options/editable-api-select-options';
import { getHmdaLoanPurposeOptions } from './hmda-loan-purpose-options.helper';

export default class HmdaLoanPurposeSelectOptions extends EditableApiSelectOptions {
	static schema(...extend: any) {
		return super.schema(
			{
				type: CustomComponentType.hmdaLoanPurposeSelectOptions
			},
			...extend
		);
	}

	static get builderInfo() {
		return {
			weight: 10,
			schema: HmdaLoanPurposeSelectOptions.schema({})
		};
	}

	protected async getApiOptions(): Promise<CollectionResponseDataFieldOption> {
		return await getHmdaLoanPurposeOptions();
	}

	protected getOptionLabelForItem(item: DataFieldOption): string {
		return item.label ?? '';
	}

	protected getOptionValueForItem(item: DataFieldOption): string {
		return (item.value as unknown) as string;
	}
}
